export { default } from './AddDevicePage';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/AddDevicePage/index.ts